const projects = [
    {
        title: "Amin Crockeries (Ecommerce)",
        description: "The Amin Crockeries project is a Django-based web application. It features inventory management, customer order handling, and sales report generation. Administrators can manage products and track stock levels, while customers can browse products, place orders, and receive status updates.",
        image: "img/img.png",
        sourceCode: "https://github.com/bhyeanhasan/Amin-Crockeries",
        liveView: "https://bhyean.pythonanywhere.com/"
    },
    {
        title: "to-sequential (Python-Package)",
        description: "A simple utility function to generate sequential data from a Pandas DataFrame, making it suitable for training data for sequential models.",
        image: "img/img_2.png",
        sourceCode: "https://github.com/bhyeanhasan/to-sequential",
        liveView: "https://pypi.org/project/to-sequential/"
    },
    {
        title: "Online Image Editor",
        description: "A dynamic online image editor utilizing Django, and OpenCV for image processing. Leveraging DTL, Bootstrap, HTML, and CSS for frontend design, I ensured responsive UI/UX. Proficient in system design and project management, I delivered a seamless platform for image manipulation and editing.",
        image: "img/img_3.png",
        sourceCode: "https://github.com/bhyeanhasan/Online-Image-Editor",
        liveView: "http://bhyeanhasan.pythonanywhere.com/"
    },
    {
        title: "Dhanshiri Students Welfare Association",
        description: "The DSWA web application represents a student-driven endeavor with the objective of creating a platform for students hailing from Jhalokathi District. Purpose is to facilitate connections between students, teachers, and alumni, while also serving as a resource for staying informed about upcoming events.",
        image: "img/img_1.png",
        sourceCode: "https://github.com/bhyeanhasan/Dhanshiri-Studets-Welfare-Association-DSWA",
        liveView: "https://dswapstu.pythonanywhere.com/"
    },
    {
        title: "Online PDF TOOLS",
        description: 'Online PDF Tools is a web-based platform that provides users with easy-to-use utilities for managing PDF documents. With a clean interface and fast processing, the tool aims to help students, professionals, and businesses work with PDFs efficiently without needing to install additional software.',
        image: "img/pdftools.png",
        sourceCode: "https://github.com/bhyeanhasan/PdfTools",
        liveView: "https://onlinepdftools.pythonanywhere.com/"
    },
    {
        title: "Research Paper Manager",
        description: 'Online PDF Tools is a web-based platform that provides users with easy-to-use utilities for managing PDF documents. With a clean interface and fast processing, the tool aims to help students, professionals, and businesses work with PDFs efficiently without needing to install additional software.',
        image: "img/research.png",
        sourceCode: "https://github.com/bhyeanhasan/Research-Paper-Manager-",
        liveView: "https://bhyeanpaper.pythonanywhere.com/"
    },
    {
        title: "Student Diary (Faculty of CSE, PSTU)",
        description: "The CSE-Diary project is a Flutter mobile app for my faculty that uses the Django Rest Framework for the backend.",
        image: "img/img_4.png",
        sourceCode: "https://github.com/bhyeanhasan/Diary-For-PSTU-CSE",
        liveView: "https://appcse16.pythonanywhere.com/"
    },
    {
        title: "Page Reloader Extension",
        description: "Enables automatic page reloading at user-defined intervals, enhancing productivity and convenience by ensuring that your web pages stay updated without manual intervention.",
        image: "img/front.png",
        sourceCode: "https://github.com/bhyeanhasan/Google-Chrome-Extention-Automatic-Page-Reloader",
        liveView: ""
    }
];

export default projects;
